export default __webpack_public_path__ + "static/media/erdstall-logo.4ca5436f.png";